// extracted by css-extract-rspack-plugin
export default {"tabsWrapper":"MaskOverlayHeader_tabsWrapper__aj9si","linearProgress":"MaskOverlayHeader_linearProgress__8guz5"};